<mat-card class="cardWithShadow text-white" style="background-color: #2641da !important;">
  <mat-card-header class="text-white">
    <mat-card-title class="text-white f-s-24">Incentivi distribuiti</mat-card-title>
    <mat-card-subtitle class="f-s-16 text-white">Da inizio anno</mat-card-subtitle>
    <div class="d-flex justify-content-between">
      <!-- <span class="icon-48 rounded-circle d-flex align-items-center justify-content-center"
        style="background-color: #daa000;">
        <i-tabler name="currency-euro" class="icon-24"></i-tabler>
      </span> -->
    </div>
  </mat-card-header>
  <mat-card-content class="p-24">
    <h5 class="text-white mat-subtitle-1 f-s-30 f-w-500 m-b-4 m-t-30 p-t-12">&euro; 1.200,00</h5>
  </mat-card-content>
</mat-card>